// Contact data helper - toggle between real and example contact information
// Set REACT_APP_SHOW_REAL_CONTACT=true in .env to display real contact details

const SHOW_REAL_CONTACT = process.env.REACT_APP_SHOW_REAL_CONTACT === 'true';

export const getContactData = () => {
  if (SHOW_REAL_CONTACT) {
    return {
      email: 'hello@travelmhor.com',
      phone: '+44 7917 106215',
      address: 'Travel Mhor House, Edinburgh, EH1 2NG'
    };
  }
  return {
    email: 'info@example.com',
    phone: '+44 7911 123456',
    address: 'Example House, City, EX1 2NG'
  };
};
